import React from "react";
import { AppBar } from "@material-ui/core";
import EmployerMenu from "./EmployerMenu/EmployerMenu";
import { DPSearchBar, DPSpacer } from "Components/DP";
import { queryToProps } from "Api";
import { goToPageCreator } from "Hooks/useGoTo";
import { useHistory, useLocation } from "Hooks/useRouter";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import ProviderSelect from "./ProviderSelect/ProviderSelect";
import useStyles from "./styles";

const TopNav = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const showSearchBar = location.pathname !== InternalRoutes.presettlementExclusions;
  const queryProps = queryToProps(location.search);
  const submitSearch = (newSearch: string) => {
    goToPageCreator(history, InternalRoutes.users)({
      ...queryProps,
      page: 1,
      search: newSearch,
    });
  };

  return (
    <AppBar
      role="navigation"
      aria-label="navigation"
      className={classes.appBar}
    >
      {showSearchBar && (
        <DPSearchBar submitSearch={submitSearch} placeholder="Find a user" />
      )}
      <DPSpacer grow={1} spacing={6} shrink={1} />
      <ProviderSelect />
      <DPSpacer spacing={6} />
      <EmployerMenu />
    </AppBar>
  );
};

export default TopNav;
